/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { connect } from 'react-redux';
import HomePage from './HomePage';
import {getHomePageData, setHomePageTitle} from '../../../_actions/home.actions';
import {login} from "../../../_thunks/home.thunk";

function mapStateToProps(state) {
    return {
        homeTitle: state.homePage.title,
        homeDescription: state.homePage.description

    };
}

const mapDispatchToProps = dispatch => {
    return {
        showHomePageData: () => {
            dispatch(getHomePageData);
        },
        updateHomePageTitle: (title) => {
            dispatch(setHomePageTitle(title));
        },
        login: payload => {
            dispatch(login(payload));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/pages/HomePage/HomePageLink.js